import React from 'react'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'

function SettingBoxesHead() {
    const canViewStoreName = checkStoreName()

    return (
        <thead className='SettingBoxesHead'>
            <tr>
                <th>Slug</th>
                <th>Shipping Box Type</th>
                <th>Box name</th>
                <th>Shipping level</th>
                <th>SKU</th>
                {canViewStoreName && <th>Store</th>}
                <th>Tag</th>
                <th>State</th>
                <th>Country</th>
                <th>Update at</th>
                <th>Action</th>
            </tr>
        </thead>
    )
}

export default SettingBoxesHead